var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsManagementactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D1EDDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L13 15V21C13 26.55 16.84 31.74 22 33C27.16 31.74 31 26.55 31 21V15L22 11ZM25.08 26L22 24.15L18.93 26L19.74 22.5L17.03 20.16L20.61 19.85L22 16.55L23.39 19.84L26.97 20.15L24.26 22.5L25.08 26Z",
    fill: "#2A8981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsManagementactive);
export default __webpack_public_path__ + "static/media/rewardsManagementactive.310c8d6fa94ba99ab30c2608f9402bc6.svg";
export { ForwardRef as ReactComponent };